import styled from 'styled-components';
import media from 'styled-media-query';

import colors from 'themes/Main';

const { warning, danger, white, gray01, darkBlue } = colors;

export const ContainerCard = styled.div`
  cursor: default;
  min-height: 205px;
  border-radius: 4px;
  background-color: ${white};
  box-shadow: 0px 1px 3px rgba(219, 219, 219, 0.2),
    0px 2px 2px rgba(219, 219, 219, 0.12), 0px 0px 2px rgba(219, 219, 219, 0.14);
  padding: 20px;

  ${media.lessThan('medium')`
    margin-top: 16px;
  `}
`;

export const TitleCard = styled.p`
  margin-bottom: 0;
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  color: ${darkBlue};
`;

export const ValueCard = styled.p`
  margin: 16px 0 0;
  font-size: 34px;
  color: ${gray01};
`;

export const StatusContainer = styled.div`
  margin-top: 16px;

  p {
    margin-bottom: 4px;
    font-size: 14px;
    color: ${gray01};
    font-weight: 700;

    &:first-child > span {
      color: ${warning};
    }

    span {
      color: ${danger};
    }
  }
`;
